export const HOSTS_TABLE_SIZING = {
  NameWidth: '40%',
  StatusWidth: '74px',
  CPUWidth: '70px',
  LoadWidth: '68px',
}
